import { StarHalfAlt } from "@styled-icons/fa-solid/StarHalfAlt";

import { Box } from "rebass";

export function EnqueteStatusHalfStarIcon() {
  return (
    <Box
      sx={{
        color: "#6463636b",
        width: "18px",
      }}
    >
      <StarHalfAlt />
    </Box>
  );
}
